import React from 'react';
import { useSelector } from 'react-redux';
import { useLocationAdmins } from '../../../../domain/Identities';
import { ProfileTabBody } from '../components/ProfileTabBody';
import { LocationAdminsTable } from './LocationAdminsTable';

/**
 * The office profile's Location Admins list (GOTU-7483), read-only.
 *
 * The office id comes from the profile's Redux `currentUser`; until that has
 * resolved the query is disabled and the card shows its loading state, since
 * an empty list there would claim nobody can act for the office.
 *
 * Assigning an admin is a follow-up: organization-service grants access by the
 * location's own UUID and has no admin route yet that finds it from an office
 * id.
 */
export const LocationAdmins = () => {
  const officeId = useSelector((state) => state.users.currentUser?.id);
  const { admins, isPending, isError } = useLocationAdmins(officeId);

  return (
    <ProfileTabBody>
      <LocationAdminsTable admins={admins} isPending={isPending || !officeId} isError={isError} />
    </ProfileTabBody>
  );
};

export default LocationAdmins;
